import { getAxiosInstance } from '../../react/utils/networkUtil';
import { AppSuccess } from '../models/AppSuccess';
import { User_Base } from '../models/User';

// Login
export type Auth_Login_Request = {
  identifier: string;
  password?: string; // or using password

  device_id?: string; // or use biometric (device_id, bio_password)
  bioPassword?: string;
};

export type Auth_Login_Response = {
  jwt: string;
  user: User_Base;
};
export const remote_Auth_login = async (request: Auth_Login_Request): Promise<Auth_Login_Response> => {
  return (await getAxiosInstance({ noAuth: true }).post('/api/auth-ext/login', request)).data;
};
// End Login

// Logout
export const remote_Auth_logout = async (): Promise<string> => {
  return (await getAxiosInstance().post('/api/auth-ext/logout', {})).data;
};
// End Logout

// Register
export type Auth_Register_Request = {
  fullname: string;
  email: string;
  phoneNumber: string;
  password: string;
};

export type Auth_Register_Response = {
  jwt: string;
  user: User_Base;
};

export const remote_Auth_register = async (bodyRegister: Auth_Register_Request): Promise<Auth_Register_Response> => {
  const { fullname, email, password, phoneNumber } = bodyRegister;
  return (await getAxiosInstance({ noAuth: true }).post('/api/auth-ext/register', {
    fullname,
    email,
    phoneNumber,
    password,
  })).data;
};
// End register

// Forgot password
export type Auth_ForgotPassword_Request = {
  email: string;
};
export type Auth_ForgotPassword_Response = AppSuccess<boolean>;
export const remote_forgotPassword = async (request: Auth_ForgotPassword_Request): Promise<Auth_ForgotPassword_Response> => {
  return (await getAxiosInstance().post('api/users-ext/forgot-password', request)).data;
};
// End forgot password

// Reset password
export type Auth_ResetPassword_Request = {
  code: string;
  newPassword: string;
};
export type Auth_ResetPassword_Response = AppSuccess<boolean>;
export const remote_resetPassword = async (request: Auth_ResetPassword_Request): Promise<Auth_ResetPassword_Response> => {
  return (await getAxiosInstance().post('api/users-ext/reset-password', request)).data;
};
// End reset password

export type Auth_DeleteMe_Request = {
  password: string;
};
export const remote_Auth_deleteMe = async (request: Auth_DeleteMe_Request): Promise<AppSuccess<any>> => {
  return (await getAxiosInstance().put('api/auth-ext/delete-me', request)).data;
};
export type Auth_RegisterBiometric_Request = {
  bioPassword: string;
  device_id: string;
};
export type Auth_RegisterBiometric_Response = AppSuccess<any>;
export const remote_Auth_registerBiometric = async (request: Auth_RegisterBiometric_Request): Promise<AppSuccess<any>> => {
  return (await getAxiosInstance().post('api/auth-ext/biometric', request)).data;
};

export type Auth_DeleteBiometric_Request = {
  device_id: string;
};
export type Auth_DeleteBiometric_Response = AppSuccess<any>;
export const remote_Auth_deleteBiometric = async (request: Auth_DeleteBiometric_Request): Promise<AppSuccess<any>> => {
  return (await getAxiosInstance().delete(`api/auth-ext/biometric/${request.device_id}`)).data;
};

export type User_ChangeMyPassword_Request = {
  oldPassword: string;
  newPassword: string;
};
export const remote_Auth_changeMyPassword = async (request: User_ChangeMyPassword_Request): Promise<AppSuccess<any>> => {
  return (await getAxiosInstance().put('api/users-ext/change-my-password', request)).data;
};

// Get My Information
export type User_GetMyInformation_Response = User_Base;
export const remote_Auth_getMyInformation = async (): Promise<User_GetMyInformation_Response> => {
  return (await getAxiosInstance().get('api/users-ext/me')).data;
};
// End Get My Information

// Update My Information
export type User_UpdateMyInfo_Request = {
  email?: string;
  fullname?: string;
  pronouns?: string;
  department?: string;
  aboutMe?: string;
  job_title?: string;
  birthday_day?: number;
  birthday_month?: number;
  birthday_year?: number;
  avatar?: File | Blob;
};
export type User_UpdateMyInfo_Response = AppSuccess<User_Base>;
export const remote_Auth_updateMyInformation = async (request: User_UpdateMyInfo_Request): Promise<User_UpdateMyInfo_Response> => {
  const formData = new FormData();
  
  if (request.email) formData.append('email', request.email);
  if (request.fullname) formData.append('fullname', request.fullname);
  if (request.pronouns) formData.append('pronouns', request.pronouns);
  if (request.department) formData.append('department', request.department);
  if (request.aboutMe) formData.append('aboutMe', request.aboutMe);
  if (request.job_title) formData.append('job_title', request.job_title);
  if (request.birthday_day) formData.append('birthday_day', request.birthday_day.toString());
  if (request.birthday_month) formData.append('birthday_month', request.birthday_month.toString());
  if (request.birthday_year) formData.append('birthday_year', request.birthday_year.toString());
  if (request.avatar) formData.append('avatar', request.avatar);
  
  return (await getAxiosInstance().put('api/users-ext/me', formData)).data;
};
// End Update My Information

export const AuthAPIs = {
  remote_Auth_login,
  remote_Auth_logout,
  remote_Auth_register,
  remote_forgotPassword,
  remote_resetPassword,
  remote_Auth_deleteMe,
  remote_Auth_registerBiometric,
  remote_Auth_deleteBiometric,
  remote_Auth_changeMyPassword,
  remote_Auth_getMyInformation,
  remote_Auth_updateMyInformation,
}
